module.exports = "<corporate-invoice-page></corporate-invoice-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomers/corporateinvoice.html
// module id = 1983
// module chunks = 0